import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const CircleInfoIcon = ({ sx, ...props }) => (
    <SvgIcon
        viewBox="0 0 14 14"
        sx={{
            height: '12px',
            width: 'auto',
            ...sx
        }}
        {...props}
    >
        <path
            d="M7 6.33333V9.66667M7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7C13 10.3137 10.3137 13 7 13ZM7.0332 4.33333V4.4L6.9668 4.40013V4.33333H7.0332Z"
            stroke="#8F8F8F"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
        />
    </SvgIcon>
);

export default CircleInfoIcon;
